export default __webpack_public_path__ + "static/media/Contact-us-Banner-640x300.c3349c8c.jpg";